document.addEventListener("DOMContentLoaded", function () {

// Third-party warning
(function () {
  "use strict";

  // Skip on sitemap page
  if (document.body && document.body.matches("body#sitemap")) {
    return;
  }

  var WARNING_TEXT =
    "Redirecting to a third-party website (opens in a new tab).";

  function decodeHtmlEntities(text) {
    if (!text) return "";

    var textarea = document.createElement("textarea");
    var decoded = text;

    for (var i = 0; i < 3; i++) {
      textarea.innerHTML = decoded;

      if (textarea.value === decoded) break;

      decoded = textarea.value;
    }

    return decoded;
  }

  function cleanLabel(text) {
    if (!text) return "";

    text = decodeHtmlEntities(text);

    return text
      .replace(/\(opens?\s+in\s+a\s+new\s+(window|tab)\)/gi, "")
      .replace(/opens?\s+in\s+a\s+new\s+(window|tab)/gi, "")
      .replace(
        /,\s*Redirecting to a third-party website\s*\(opens in a new tab\)\.?/gi,
        ""
      )
      .replace(
        /Redirecting to a third-party website\s*\(opens in a new tab\)\.?/gi,
        ""
      )
      .replace(/\s+/g, " ")
      .trim();
  }

  function getIconLabel(link) {
    var classes = (link.className || "").toLowerCase();
    var href = (link.href || "").toLowerCase();

    var platforms = [
      ["facebook", "Follow us on Facebook"],
      ["instagram", "Follow us on Instagram"],
      ["twitter", "Follow us on X"],
      ["x.com", "Follow us on X"],
      ["youtube", "Visit our YouTube channel"],
      ["linkedin", "Connect with us on LinkedIn"],
      ["pinterest", "Follow us on Pinterest"],
      ["tiktok", "Follow us on TikTok"],
      ["threads", "Follow us on Threads"],
      ["snapchat", "Follow us on Snapchat"],
      ["whatsapp", "Contact us on WhatsApp"],
      ["vimeo", "Visit our Vimeo page"],
      ["flickr", "Visit our Flickr page"]
    ];

    for (var i = 0; i < platforms.length; i++) {
      if (
        classes.indexOf(platforms[i][0]) !== -1 ||
        href.indexOf(platforms[i][0]) !== -1
      ) {
        return platforms[i][1];
      }
    }

    return "External link";
  }

  function updateExternalLinks() {
    document.querySelectorAll("a[href]").forEach(function (link) {
      var href = link.getAttribute("href");

      if (!href) return;

      if (
        href.indexOf("mailto:") === 0 ||
        href.indexOf("tel:") === 0 ||
        href.indexOf("javascript:") === 0 ||
        href.indexOf("#") === 0
      ) {
        return;
      }

      var url;

      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      var currentHostname = window.location.hostname.replace(/^www\./, "");
      var linkHostname = url.hostname.replace(/^www\./, "");

      // Same-domain links are ignored
      if (linkHostname === currentHostname) {
        return;
      }

      var existingAriaLabel =
        link.getAttribute("aria-label") || "";

      // If warning already exists, only remove title
      if (
        existingAriaLabel
          .toLowerCase()
          .indexOf(WARNING_TEXT.toLowerCase()) !== -1
      ) {
        if (link.hasAttribute("title")) {
          link.removeAttribute("title");
        }

        return;
      }

      var label = cleanLabel(
        link.getAttribute("title") ||
        existingAriaLabel ||
        link.textContent ||
        ""
      );

      if (!label) {
        label = getIconLabel(link);
      }

      link.setAttribute(
        "aria-label",
        label + ", " + WARNING_TEXT
      );

      // Remove title because aria-label is now available
      if (link.hasAttribute("title")) {
        link.removeAttribute("title");
      }

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }

  updateExternalLinks();
})();
// End Third-party warning

// Start Swatch aria-label
function updateSwatchAriaLabels() {
  document.querySelectorAll(".product-item__info").forEach(function (productInfo) {
    var productTitle = productInfo.querySelector(".product-item__title");

    if (!productTitle) return;

    var title = productTitle.textContent.trim();

    if (!title) return;

    productInfo.querySelectorAll(".swatch__link").forEach(function (swatchLink) {
      var colorName = swatchLink.querySelector("[data-swatch-text]");

      if (!colorName) return;

      var color = colorName.textContent.trim();

      if (!color) return;

      swatchLink.setAttribute(
        "aria-label",
        "Variant: " + title + ", Color: " + color
      );
    });
  });
}

updateSwatchAriaLabels();

var swatchObserver = new MutationObserver(function () {
  updateSwatchAriaLabels();
});

swatchObserver.observe(document.body, {
  childList: true,
  subtree: true
});
// End Swatch aria-label

// Start Search dialog focus
document.addEventListener("click", function (event) {
  var closeButton = event.target.closest("button.search-popdown__close__button");

  if (!closeButton) return;

  setTimeout(function () {
    var searchDetails = closeButton.closest("details");
    var searchTrigger = searchDetails
      ? searchDetails.querySelector("summary.navlink.navlink--search")
      : null;

    if (searchTrigger) {
      searchTrigger.focus();
    }
  }, 1000);
});
// End Search dialog focus

// Start header Cart dialog focus
var lastCartTrigger = null;

document.addEventListener("click", function (event) {
  var cartTrigger = event.target.closest("a.navlink.navlink--cart.navlink--cart--icon");

  if (cartTrigger) {
    lastCartTrigger = cartTrigger;
    return;
  }

  var cartCloseButton = event.target.closest("button.drawer__close[data-cart-drawer-close]");

  if (!cartCloseButton) return;

  setTimeout(function () {
    if (lastCartTrigger) {
      lastCartTrigger.focus();
    }
  }, 500);
});
// End header Cart dialog focus

// Product page Add to Cart dialog focus
var lastAddToCartTrigger = null;

document.addEventListener("click", function (event) {
  var addToCartButton = event.target.closest(
    "button.btn-add-to-cart[data-add-to-cart]"
  );

  if (addToCartButton) {
    lastAddToCartTrigger = addToCartButton;
    return;
  }

  var cartCloseButton = event.target.closest(
    "button.drawer__close[data-cart-drawer-close]"
  );

  if (!cartCloseButton) return;

  if (!lastAddToCartTrigger) return;

  setTimeout(function () {
    if (document.contains(lastAddToCartTrigger)) {
      lastAddToCartTrigger.focus();
    }
  }, 500);
});
// End product page Add to Cart dialog focus

// Start Article link aria-label
var articlePage = document.querySelector(
  "body.template-article"
);

if (articlePage) {
  articlePage.querySelectorAll("a[title]").forEach(function (link) {
    var title = link.getAttribute("title");

    if (!title) return;

    link.setAttribute("aria-label", title);
    link.removeAttribute("title");
  });
}
// End Article link aria-label


// Start: Contact Form Submit Button Accessibility
setTimeout(function () {
  const contactSubmitButton = document.querySelector(
    'form#contact-form button.btn.btn--primary.btn--solid.btn--full'
  );

  if (contactSubmitButton) {
    const buttonText = contactSubmitButton.textContent.trim();

    contactSubmitButton.setAttribute(
      'aria-label',
      `${buttonText}, after successful submission the page will be refreshed`
    );
  }
}, 1000);
// End: Contact Form Submit Button Accessibility

// Start: Add aria-hidden to HR and BR tags
document.querySelectorAll("hr, br").forEach(function (element) {
  element.setAttribute("aria-hidden", "true");
});
// End: Add aria-hidden to HR and BR tags

// Start: Mobile Footer Menu Accessibility
if (window.innerWidth <= 767) {
  document.querySelectorAll(
    ".footer__block.footer__block--menu > h2.footer__block__title"
  ).forEach((heading) => {
    const toggle = heading.querySelector(".footer__mobile-menu-toggle");

    if (!toggle) return;

    // Replace H2 with DIV
    const div = document.createElement("div");
    div.className = heading.className;

    // Move existing content into DIV
    while (heading.firstChild) {
      div.appendChild(heading.firstChild);
    }

    heading.replaceWith(div);

    // Accessibility attributes
    toggle.setAttribute("role", "button");
    toggle.setAttribute("tabindex", "0");
    toggle.setAttribute("aria-expanded", "false");

    // Toggle aria-expanded
    toggle.addEventListener("click", function () {
      const currentState = this.getAttribute("aria-expanded") === "true";

      this.setAttribute(
        "aria-expanded",
        currentState ? "false" : "true"
      );
    });

    // Keyboard support
    toggle.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.click();
      }
    });
  });
}
// End: Mobile Footer Menu Accessibility

// Start Updating aria-hidden on the sliders
(function () {

  const sliderSelector =
    '.grid-container .grid-item';


  function initAccessibleSliders() {


    document.querySelectorAll('.index-tab-collections').forEach(function (section) {


      const slides = Array.from(
        section.querySelectorAll(sliderSelector)
      );


      if (!slides.length) return;


      const nextButton =
        section.querySelector('[data-button-next]');


      const prevButton =
        section.querySelector('[data-button-prev]');


      let navigationClicked = false;



      function updateAccessibility() {


        slides.forEach(function (slide) {


          if (slide.classList.contains('is-visible')) {


            slide.setAttribute(
              'aria-hidden',
              'false'
            );

            slide.removeAttribute('role');
            slide.removeAttribute('tabindex');


          } else {


            slide.setAttribute(
              'aria-hidden',
              'true'
            );

            slide.setAttribute(
              'role',
              'presentation'
            );

            slide.setAttribute(
              'tabindex',
              '-1'
            );


          }


        });


      }



      /*
       Initial update after slider initialization
      */
      updateAccessibility();



      nextButton?.addEventListener('click', function () {

        navigationClicked = true;

      });


      prevButton?.addEventListener('click', function () {

        navigationClicked = true;

      });



      const observer = new MutationObserver(function () {


        if (!navigationClicked) {
          return;
        }


        setTimeout(function () {

          updateAccessibility();

          navigationClicked = false;

        }, 300);


      });



      slides.forEach(function (slide) {

        observer.observe(slide, {

          attributes: true,
          attributeFilter: ['class']

        });

      });


    });

  }



  /*
   Wait until Shopify/theme slider creates is-visible
  */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        setTimeout(initAccessibleSliders, 500);

      }
    );

  } else {

    setTimeout(initAccessibleSliders, 500);

  }


})();
// End Updating aria-hidden on the sliders

// Product page quick add button focus triggering
let lastUpsellButton = null;

document.addEventListener('click', function (event) {
  const upsellButton = event.target.closest(
    '.btn__outer button.product-upsell__btn'
  );

  if (upsellButton) {
    lastUpsellButton = upsellButton;
    return;
  }

  const closeButton = event.target.closest(
    'button.product-quick-add__close.drawer__close'
  );

  if (closeButton && lastUpsellButton) {
    const buttonToFocus = lastUpsellButton;

    setTimeout(() => {
      // Focus only if the exact button still exists in the DOM
      if (document.contains(buttonToFocus)) {
        buttonToFocus.focus();
      }
    }, 100);
  }
});
// End Product page quick add button focus triggering

// Second Quick add button focus triggering
(function () {
  let lastQuickAddButton = null;
  let lastProductLink = null;

  document.addEventListener("click", function (e) {

    const quickAdd = e.target.closest(
      "button.quick-add__button.caps"
    );

    const closeButton = e.target.closest(
      "button.product-quick-add__close.drawer__close"
    );


    // Store Quick Add button and product link
    if (quickAdd) {

      lastQuickAddButton = quickAdd;

      lastProductLink = quickAdd
        .closest(".product-item__image")
        ?.querySelector("a.product-link");

    }



    // Return focus after closing
    if (closeButton) {

      setTimeout(() => {


        // If Quick Add button is visible, focus it
        if (
          lastQuickAddButton &&
          lastQuickAddButton.offsetParent !== null
        ) {

          lastQuickAddButton.focus();

        }

        // Otherwise focus product link
        else if (lastProductLink) {

          lastProductLink.focus();

        }


      }, 100);

    }

  });

})();
// End Second Quick add button focus triggering

//Filter fixes on mobile devices
(function () {
  "use strict";

  const MOBILE_BREAKPOINT = 749;

  if (window.innerWidth > MOBILE_BREAKPOINT) return;


  const FILTER_BUTTON =
    "button.popout__toggle.popout__toggle--filters";

  const FILTER_DIALOG =
    "#filter-groups";

  const CLOSE_BUTTON =
    ".collection__sidebar__close";


  let lastFocusedButton = null;



  function setupFilterAccessibility() {

    const filterButton = document.querySelector(FILTER_BUTTON);
    const dialog = document.querySelector(FILTER_DIALOG);


    if (!filterButton || !dialog) return;


    /*
     * Filter button attributes
     */
    filterButton.removeAttribute("aria-expanded");

    filterButton.setAttribute(
      "aria-haspopup",
      "dialog"
    );


    /*
     * Keep existing UI text working
     */
    const showText = filterButton.querySelector(
      ".popout__expanded-show"
    );

    const hideText = filterButton.querySelector(
      ".popout__expanded-hide"
    );


    if (showText && hideText) {

      showText.style.display = "inline";
      hideText.style.display = "none";

    }



    /*
     * Dialog attributes
     */
    dialog.setAttribute(
      "role",
      "dialog"
    );

    dialog.setAttribute(
      "aria-modal",
      "true"
    );

  }




  setupFilterAccessibility();



  /*
   * Prevent Shopify from adding aria-expanded again
   */
  const observer = new MutationObserver(function () {

    setupFilterAccessibility();

  });


  observer.observe(
    document.body,
    {
      subtree: true,
      attributes: true,
      attributeFilter: [
        "aria-expanded"
      ]
    }
  );





  document.addEventListener(
    "click",
    function (event) {


      /*
       * Open Filter
       */
      const filterButton = event.target.closest(
        FILTER_BUTTON
      );


      if (filterButton) {


        lastFocusedButton = filterButton;


        const showText =
          filterButton.querySelector(
            ".popout__expanded-show"
          );

        const hideText =
          filterButton.querySelector(
            ".popout__expanded-hide"
          );


        if (showText && hideText) {

          showText.style.display = "none";
          hideText.style.display = "inline";

        }



        setTimeout(function () {

          const closeButton =
            document.querySelector(
              CLOSE_BUTTON
            );


          if (closeButton) {

            closeButton.focus();

          }

        }, 300);


      }





      /*
       * Close Filter
       */
      const closeButton = event.target.closest(
        CLOSE_BUTTON
      );


      if (closeButton) {


        if (lastFocusedButton) {


          const showText =
            lastFocusedButton.querySelector(
              ".popout__expanded-show"
            );


          const hideText =
            lastFocusedButton.querySelector(
              ".popout__expanded-hide"
            );


          if (showText && hideText) {

            showText.style.display = "inline";
            hideText.style.display = "none";

          }



          setTimeout(function () {

            lastFocusedButton.focus();

          }, 300);


        }

      }


    }
  );


})();
//End Filter fixes on mobile devices

//Adding aria-labels on product pages
(function () {
  const links = document.querySelectorAll(
    ".form__width .product__block.product__description.rte .product__description__content.rte a"
  );

  links.forEach(function (link) {

    const text = link.textContent.trim();

    if (text) {

      // Add aria-label from visible text
      link.setAttribute(
        "aria-label",
        text
      );

      // Remove title attribute
      link.removeAttribute("title");

    }

  });

})();
//End Adding aria-labels on product pages

//Slider anchors aria-label update
document.querySelectorAll("a.product-link").forEach(function (link) {

  const image = link.querySelector(
    ".product-item__bg__under img"
  );

  if (image) {
    const altText = image.getAttribute("alt");

    if (altText && altText.trim()) {
      link.setAttribute("aria-label", `View ${altText}`);
    }
  }

});
//End Slider anchors aria-label update

//Desktop menu removing attributes
(function () {
  function removeMenuAttributes() {
    document
      .querySelectorAll('.header__desktop__bar__c .header__menu .menu__item')
      .forEach(function (item) {
        item.removeAttribute('aria-expanded');
        item.removeAttribute('aria-haspopup');
      });
  }

  // Initial load par remove karein
  removeMenuAttributes();

  // Agar koi script dobara attributes add kare to remove kar dein
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        const target = mutation.target;

        if (
          target.matches(
            '.header__desktop__bar__c .header__menu .menu__item'
          )
        ) {
          target.removeAttribute('aria-expanded');
          target.removeAttribute('aria-haspopup');
        }
      }
    });
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-expanded', 'aria-haspopup']
  });
})();
//End Desktop menu removing attributes

//Mobile menu button fixes
(function () {

  const selectors = [
    '.header__mobile__left .header__mobile__button .header__mobile__hamburger',
    '.drawer__head .drawer__close',
    '.header__mobile__button .navlink navlink--search'
  ];


  function removeExpandedAttribute() {
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        element.removeAttribute('aria-expanded');
      });
    });
  }


  // Initial load par remove karein
  removeExpandedAttribute();


  // Agar koi script dobara aria-expanded add kare to remove kar dein
  const observer = new MutationObserver(function (mutations) {

    mutations.forEach(function (mutation) {

      if (mutation.type === 'attributes') {

        const target = mutation.target;

        selectors.forEach(function (selector) {

          if (target.matches(selector)) {
            target.removeAttribute('aria-expanded');
          }

        });

      }

    });

  });


  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-expanded']
  });

})();
//End Mobile menu button fixes

//Mobile menu focus triggering
(function () {

  const menuButtonSelector = 'button.header__mobile__hamburger';
  const closeButtonSelector = 'button.drawer__close';

  let lastFocusedMenuButton = null;


  // Store the last focused menu button
  document.addEventListener('focusin', function (event) {
    const target = event.target;

    if (target.matches(menuButtonSelector)) {
      lastFocusedMenuButton = target;
    }
  });


  // Return focus to the menu button after closing the drawer
  document.addEventListener('click', function (event) {

    const closeButton = event.target.closest(closeButtonSelector);

    if (closeButton) {

      setTimeout(function () {

        if (lastFocusedMenuButton) {
          lastFocusedMenuButton.focus();
        } else {
          const menuButton = document.querySelector(menuButtonSelector);

          if (menuButton) {
            menuButton.focus();
          }
        }

      }, 100);

    }

  });

})();
//End Mobile menu focus triggering

//Mobile submenu focus triggering
(function () {

  const submenuTriggerSelector = 'button.sliderow';
  const backButtonSelector = 'button.sliderow__back-button';
  const visiblePanelSelector = '.sliderule__panel.is-visible';

  let lastTriggerElement = null;


  // Store the submenu trigger button
  document.addEventListener('click', function (event) {

    const trigger = event.target.closest(submenuTriggerSelector);

    if (trigger && trigger.getAttribute('data-sliderule-open')) {

      lastTriggerElement = trigger;

      // Wait until submenu panel becomes visible
      const focusBackButton = setInterval(function () {

        const panel = document.querySelector(visiblePanelSelector);

        if (panel) {

          const backButton = panel.querySelector(backButtonSelector);

          if (backButton) {
            backButton.focus();
            clearInterval(focusBackButton);
          }

        }

      }, 50);


      // Stop checking after 2 seconds
      setTimeout(function () {
        clearInterval(focusBackButton);
      }, 2000);

    }

  });


  // Return focus to the trigger button when submenu is closed
  document.addEventListener('click', function (event) {

    const backButton = event.target.closest(backButtonSelector);

    if (backButton) {

      setTimeout(function () {

        if (lastTriggerElement) {
          lastTriggerElement.focus();
        }

      }, 300);

    }

  });

})();
//End Mobile submenu focus triggering

// //Mobile product gallery slider
// (function () {

//   // Run only on mobile devices
//   if (window.innerWidth > 768) return;


//   const gallerySelector = '.product__images';
//   const slidesSelector = '.product__images .product__slides .product__slide';
//   const nextButtonSelector = '.slider__button--next';
//   const prevButtonSelector = '.slider__button--prev';


//   const gallery = document.querySelector(gallerySelector);

//   if (!gallery) return;


//   let slides = Array.from(
//     gallery.querySelectorAll(slidesSelector)
//   );

//   let currentIndex = slides.findIndex(function (slide) {
//     return slide.classList.contains('media--active');
//   });


//   if (currentIndex < 0) {
//     currentIndex = 0;
//   }


//   function updateSlideAccessibility() {

//     slides.forEach(function (slide, index) {

//       if (index === currentIndex) {

//         slide.classList.add('media--active');
//         slide.classList.remove('media--hiding');

//         slide.setAttribute('aria-hidden', 'false');
//         slide.removeAttribute('role');
//         slide.removeAttribute('tabindex');

//       } else {

//         slide.classList.remove('media--active');
//         slide.classList.add('media--hiding');

//         slide.setAttribute('aria-hidden', 'true');
//         slide.setAttribute('role', 'presentation');
//         slide.setAttribute('tabindex', '-1');

//       }

//     });

//   }


//   function goToSlide(index) {

//     if (index < 0) {
//       index = slides.length - 1;
//     }

//     if (index >= slides.length) {
//       index = 0;
//     }


//     slides[currentIndex].classList.remove('media--active');
//     slides[currentIndex].classList.add('media--hiding');


//     currentIndex = index;


//     slides[currentIndex].classList.add('media--active');
//     slides[currentIndex].classList.remove('media--hiding');


//     updateSlideAccessibility();

//   }


//   const nextButton = gallery.querySelector(nextButtonSelector);

//   if (nextButton) {

//     nextButton.addEventListener('click', function () {

//       goToSlide(currentIndex + 1);

//     });

//   }


//   const prevButton = gallery.querySelector(prevButtonSelector);

//   if (prevButton) {

//     prevButton.addEventListener('click', function () {

//       goToSlide(currentIndex - 1);

//     });

//   }


//   updateSlideAccessibility();


// })();
// //End Mobile product gallery slider

// Mobile only slider accessibility fix
(function () {

  function initMobileSliderAccessibility() {

    // Only mobile
    if (window.innerWidth > 767) return;


    const sliderItems = document.querySelectorAll(
      ".grid-outer .slider--small-arrows .grid .grid-item.product-item"
    );

    if (!sliderItems.length) return;


    let updateTimer;


    function updateSliderAccessibility() {

      clearTimeout(updateTimer);

      updateTimer = setTimeout(function () {

        sliderItems.forEach(function (item) {

          if (item.classList.contains("is-visible")) {

            item.setAttribute("aria-hidden", "false");

            item.removeAttribute("role");
            item.removeAttribute("tabindex");

          } else {

            item.setAttribute("aria-hidden", "true");

            item.setAttribute("role", "presentation");

            item.setAttribute("tabindex", "-1");

          }

        });

      }, 300);

    }


    // Initial update
    updateSliderAccessibility();


    // Observe class changes
    const observer = new MutationObserver(function () {

      updateSliderAccessibility();

    });


    sliderItems.forEach(function (item) {

      observer.observe(item, {
        attributes: true,
        attributeFilter: ["class"]
      });

    });

  }


  // Delay because Shopify recommendation loads after page
  window.addEventListener("load", function () {

    setTimeout(function () {
      initMobileSliderAccessibility();
    }, 1000);

  });


  // Shopify theme editor
  document.addEventListener(
    "shopify:section:load",
    function () {

      setTimeout(function () {
        initMobileSliderAccessibility();
      }, 500);

    }
  );


})();

// Desktop dropdown click toggle only
if (window.matchMedia('(min-width: 1024px)').matches) {

  const menuItems = document.querySelectorAll(
    '.header__desktop__bar__c .menu__item[data-hover-disclosure-toggle]'
  );

  menuItems.forEach((menuItem) => {

    const button = menuItem.querySelector(
      'button.navlink--toplevel'
    );

    const dropdownId = menuItem.getAttribute(
      'data-hover-disclosure-toggle'
    );

    const dropdown = document.getElementById(dropdownId);

    if (!button || !dropdown) return;

    button.addEventListener('click', () => {

      const isOpen = button.getAttribute('aria-expanded') === 'true';

      // Close all dropdowns
      menuItems.forEach((item) => {

        const itemButton = item.querySelector(
          'button.navlink--toplevel'
        );

        const itemDropdown = document.getElementById(
          item.getAttribute('data-hover-disclosure-toggle')
        );

        if (!itemButton || !itemDropdown) return;

        itemButton.setAttribute('aria-expanded', 'false');

        item.classList.remove('is-visible');
        itemDropdown.classList.remove('is-visible');
      });

      // Open clicked dropdown
      if (!isOpen) {

        button.setAttribute('aria-expanded', 'true');

        menuItem.classList.add('is-visible');
        dropdown.classList.add('is-visible');
      }
    });
  });


  // Escape key closes dropdown
  document.addEventListener('keydown', (e) => {

    if (e.key !== 'Escape') return;

    menuItems.forEach((menuItem) => {

      const button = menuItem.querySelector(
        'button.navlink--toplevel'
      );

      const dropdown = document.getElementById(
        menuItem.getAttribute('data-hover-disclosure-toggle')
      );

      if (!button || !dropdown) return;

      if (button.getAttribute('aria-expanded') === 'true') {

        button.setAttribute('aria-expanded', 'false');

        menuItem.classList.remove('is-visible');
        dropdown.classList.remove('is-visible');

        button.focus();
      }
    });
  });

}
// End Desktop dropdown click toggle only
});